<template>
  <div class="availability-calendar">
    <div class="color-labels">
      <div class="color-label-title">
        <span class="text">Renkler</span>
      </div>
      <div class="color-label label-today">
        <span class="label"></span>
        <span class="text">Uygun</span>
      </div>
      <div class="color-label label-marked">
        <span class="label"></span>
        <span class="text">Dolu</span>
      </div>
    </div>
    <FunctionalCalendar
      :key="key"
      class="calendar"
      date-format="yyyy-mm-dd"
      :marked-dates="markedDates"
      :calendars-count="2"
      :is-multiple="true"
      :limits="limits"
      :hidden-elements="['leftAndRightDays']"
      :enabled-dates="availableDays"
      :disabled-dates="['beforeToday']"
      :day-names="names.day"
      :month-names="names.month"
    ></FunctionalCalendar>
  </div>
</template>

<script>
import FunctionalCalendarPlugin, {
  FunctionalCalendar
} from 'vue-functional-calendar'

export default {
  components: {
    FunctionalCalendar,
    FunctionalCalendarPlugin
  },
  props: {
    availability: {
      type: Object,
      required: true
    },
    forAdmin: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      key: 0,
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 1000)),
      limits: {
        min: this.toString(new Date()),
        max: this.toString(
          new Date(new Date().setDate(new Date().getDate() + 1000))
        )
      },
      names: {
        day: ['Pzt', 'Sal', 'Çrş', 'Prş', 'Cum', 'Cts', 'Pzr'],
        month: [
          'Ocak',
          'Şubat',
          'Mart',
          'Nisan',
          'Mayıs',
          'Haziran',
          'Temmuz',
          'Ağustos',
          'Eylül',
          'Ekim',
          'Kasım',
          'Aralık'
        ]
      }
    }
  },
  computed: {
    dates() {
      let arr = []
      let dt = new Date(
        this.startDate.getFullYear(),
        this.startDate.getMonth(),
        1
      )
      while (dt <= this.endDate) {
        let data = this.availability[this.toDataString(dt)]
        if (data) {
          data.remainingCapacity = '0'
        }
        arr.push({
          date: new Date(dt),
          str: this.toString(dt),
          data: data
        })
        dt.setDate(dt.getDate() + 1)
      }
      this.$emit('update:dates', arr)
      return arr
    },
    availableDays() {
      return this.dates.filter(d => !!d.data).map(d => d.str)
    },
    markedDates() {
      const res = this.dates
        .filter(d => !!d.data)
        .map(d => ({
          date: d.str,
          class: +d.remainingCapacity === 0 ? 'full-reserved' : 'available'
        }))
      this.loaded()
      return res
    }
  },
  methods: {
    loaded() {
      this.key++
    },
    toDate(date) {
      if (date < 10) return `0${date}`
      return date
    },
    toString(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    toDataString(date) {
      return `${date.getFullYear()}-${this.toDate(
        date.getMonth() + 1
      )}-${this.toDate(date.getDate())}`
    }
  }
}
</script>

<style lang="scss">
.availability-calendar {
  .vfc-week .vfc-day span.vfc-span-day.vfc-today {
    background-color: unset;
  }

  .vfc-week .vfc-day span.vfc-span-day.vfc-marked:before {
    background-color: #eb6081 !important;
  }

  .vfc-week .vfc-day span.vfc-span-day:not(.vfc-disabled) {
    &.available {
      background-color: #23daa9 !important;
      color: #fff;
    }
    &.full-reserved {
      background-color: #eb6081 !important;
      color: #fff;
    }
  }
}

.color-labels {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 1rem;
  .color-label {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    .label {
      display: inline-block;
      width: 1rem;
      height: 1rem;
      border-radius: 50%;
      margin-right: 0.5rem;
      content: ' ';
    }
    &-title {
      margin-bottom: 0.5rem;
      .text {
        font-size: 1rem;
        font-weight: 500;
        color: #4a4a4a;
        margin: 0;
      }
    }
    .text {
      font-size: 0.875rem;
      font-weight: 500;
      color: #4a4a4a;
      margin: 0;
    }
    &.label-today {
      .label {
        background-color: #23daa9;
      }
    }
    &.label-marked {
      .label {
        background-color: #eb6081;
      }
    }
  }
}
</style>
